import {InjectionToken} from '@angular/core';
import {AppUrls, path} from 'app/core/url/app-urls.service';

export type Redirect = (url: string) => void;

export const REDIRECT_TO_LEGACY_LOGIN = new InjectionToken<() => void>('redirectToHome');
export const REDIRECT = new InjectionToken<() => void>('redirectFunction');

const backPathDenyList = ['logout', 'sign-out', AppUrls.SIGN_OUT, AppUrls.SIGN_IN, 'oauth'];

export const isBackPathAllowed = backToPath => !backPathDenyList.some(pathName => backToPath.startsWith('/' + pathName));

/* istanbul ignore next */
let redirectToSignin = () => {
    if (location.pathname.startsWith(path(AppUrls.SIGN_IN))) {
        return;
    }
    if (location.pathname === '/' || !isBackPathAllowed(location.pathname)) {
        return redirectFn(path(AppUrls.SIGN_IN));
    }
    const backToPath = location.pathname + location.search + location.hash;

    return redirectFn(path(AppUrls.SIGN_IN_BACK_TO, encodeURIComponent(backToPath)));
};

export const LEGACY_REDIRECT_TO_LOGIN_PROVIDER = {
    provide: REDIRECT_TO_LEGACY_LOGIN,
    useValue: redirectToSignin,
};

let redirectFn: Redirect = (url: string) => {
    window.location.href = url;
};

export const REDIRECT_PROVIDER = {
    provide: REDIRECT,
    useValue: redirectFn,
};
